/**
 * Compares two dates and returns a list of each year between those dates.
 */
export function dateRangeYear(startDate: Date, endDate: Date) {
  return Array(endDate.getFullYear() - startDate.getFullYear() + 1)
    .fill(startDate.getFullYear())
    .map((year, index) => year + index);
}
